const mapping: Record<
  string,
  (lambdaParameter: string, value: any, otherValues: any) => string | null
> = {
  description: (lambdaParameter, value) =>
    `${lambdaParameter}.Description.Contains("${value}")`,
  engineMediaActionId: (lambdaParameter, value) =>
    `${lambdaParameter}.EngineMediaAction.Id.Equals(${value})`,
  filterPackId: () => null,
  packId: (lambdaParameter, value, otherValues) =>
    otherValues.filterPackId === false
      ? null
      : `${lambdaParameter}.EngineMediaPacks.Any(pck=>pck.Id==${value})`,
}

const filterMapper = (key: string) =>
  mapping[key] as (
    lambdaParameter: string,
    value: any,
    otherValues: any,
  ) => string

export default filterMapper
